/** Formatting helpers shared across owner-portal pages. */

import { formatMoney as money, initials as initialsOf, uid, type CurrencyOpts } from "@cliqsuite/ui";

export type { CurrencyOpts };
export { money, initialsOf, uid };

export function compactMoney(amount: number | null | undefined, opts?: CurrencyOpts): string {
  const n = amount ?? 0;
  const currency = opts?.currencyCode ?? "MMK";
  if (Math.abs(n) >= 1_000_000) return `${currency} ` + (n / 1_000_000).toFixed(1) + "M";
  if (Math.abs(n) >= 1_000) return `${currency} ` + (n / 1_000).toFixed(1) + "K";
  return money(n, opts);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso).getTime();
  if (Number.isNaN(d)) return "—";
  const diffMs = Date.now() - d;
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return mins + "m ago";
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return hrs + "h ago";
  const days = Math.round(hrs / 24);
  return days + "d ago";
}

/** "08:00" / "08:00:00" (Postgres time) -> "8:00 AM". */
export function formatTimeOfDay(t: string | null | undefined): string {
  if (!t) return "—";
  const [h, m] = t.split(":");
  const hour = Number(h);
  if (Number.isNaN(hour)) return "—";
  const period = hour >= 12 ? "PM" : "AM";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12}:${m ?? "00"} ${period}`;
}
